var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResellers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.74 13.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e3f76;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.87,
    cy: 6.87,
    r: 6.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.06,8A1.25,1.25,0,1,0,5.81,6.75,1.25,1.25,0,0,0,7.06,8Zm.5.47h-1a1.69,1.69,0,0,0-1.69,1.69.34.34,0,0,0,.33.34h3.7a.34.34,0,0,0,.34-.34A1.69,1.69,0,0,0,7.56,8.47Zm2,.15H8.83a2,2,0,0,1,.73,1.54.67.67,0,0,1-.1.34h1.35a.31.31,0,0,0,.31-.32A1.56,1.56,0,0,0,9.55,8.62ZM9.09,8a1.1,1.1,0,1,0,0-2.19A1.13,1.13,0,0,0,8.44,6a1.6,1.6,0,0,1,.18.72,1.57,1.57,0,0,1-.3.93A1.06,1.06,0,0,0,9.09,8Z",
    transform: "translate(-1.13 -1.13)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResellers);
export default __webpack_public_path__ + "static/media/Resellers.ded4edb8f878f46bb0d9d8ff20b4470b.svg";
export { ForwardRef as ReactComponent };